import { ViewRoom } from '@xeetr/types/models'

import ApiService from './common/API.service'

export class RoomService extends ApiService {
  getRooms = async (): Promise<ViewRoom[]> => {
    const { data } = await this.get<ViewRoom[]>(this.buildCommonUrl('rooms'))
    return data
  }

  patchRoom = async (id: string, room: Partial<ViewRoom>): Promise<ViewRoom> => {
    const { data } = await this.patch<unknown, ViewRoom>(this.buildCommonUrl(`rooms/${id}`), room)
    return data
  }

  createRoom = async (room: ViewRoom): Promise<ViewRoom> => {
    const { data } = await this.post<ViewRoom, ViewRoom>(this.buildCommonUrl('rooms'), room)
    return data
  }

  deleteRoom = async (id: string): Promise<void> => {
    await this.delete(this.buildCommonUrl(`rooms/${id}`))
  }
}
